<template>
  <div>
    <div class="card-header pl-0">
      <div class="d-flex justify-content-between align-items-center">
        <span class="ml-3"><img class="heading-icon mr-2" src="~@/assets/device_hub_icon.svg"/> Inspector</span>
        <div class="btn-menu-wrapper navbar navbar-expand-lg">
          <ul class="navbar-nav">
            <li class="nav-item">
              <span class="nav-link"
                    @click="activeComponent = 'main'"
                    :class="{'active':activeComponent == 'main'}">
                Main
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="inspector-wrapper">
    <template>
      <div class="row"></div>

    <div class="row">
      <div class="col-9">
        <maininspector v-if="activeComponent == 'main'"></maininspector>
      </div>
      <div class="col-3">
        <h4 v-if="selectedEffect">{{ selectedEffect.name }}</h4>
        <div class="selected-char-imgwrap mr-4">
          <img :src="selectedEffect.objectDbHash && effects[selectedEffect.objectDbHash].image.imageURL" class="img-fluid" style="width:100%"/>
        </div>
      </div>
    </div>
    <div class="row mt-4 d-none">
      <div class="col-12 text-center">
        <button class="btn btn-outline-primary mr-3">Save</button>
        <button class="btn btn-outline-secondary">Cancel</button>
      </div>
    </div>
    </template>
  </div>
  </div>
  </div>
</template>

<script>

import maininspector from '../inspector-components/effects/maininspector'
import $ from 'jquery'
import { mapState } from 'vuex'

export default {
  name: 'effectsInspector',
  data () {
    return {
      showModal: false,
      activeComponent: 'main',
      selectedEffect: '',
    }
  },
  created () {
    // this.openModal()
  },
  components: {
    maininspector
  },
  methods: {
    openModal () {
      this.showModal = true
      this.$nextTick(() => {
        $('#effects-modal').modal('show')
      })
    },
    closeModal () {
      $('.modal').modal('hide')
      this.showModal = false
    },

    changeShadow () {
      this.$emit('showShadowChange', {'showShadow': this.showShadow})
    },
    changeSkeleton () {
      this.$emit('showSkeletonChange', {'showSkeletonToggle': this.showSkeleton})
    },
    changeSelectedAnimation (data) {
      this.$emit('showSelectedAnimation', {'selectedAnimation': data.selectedAnimation})
    },
    changeSelectedModel (data) {
      this.selectedEffect = data.imageurl
      this.$emit('showSelectedModel', {'selectedFbxModel': data.index})
    },
  },
  mounted() {
    for (let i = 0; i < this.characters.length; i++) {
      const char = this.characters[i]
      if (char.active) {
        this.selectedEffect = char
      }
    }
  },
  computed: {
    ...mapState(['characters', 'effects'])
  },
  watch: {
    characters (val) {
      for (let i = 0; i < val.length; i++) {
        const char = val[i]
        if (char.active) {
          this.selectedEffect = char
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-wrap/effectsInspector.vue